<script lang="ts">
	import { userInfo } from '../../stores';
	import { getClient, mutate } from 'svelte-apollo';
	import { deleteUser } from '../../graphql/queries/users';
	import type { User } from 'Users';
	import { createEventDispatcher } from 'svelte';
	import { Link } from 'svelte-routing';

	const client = getClient();
	const dispatch = createEventDispatcher();

	export let row: User;

	const deleteIcon = '/assets/images/delete_icon.svg';
	const editIcon = '/assets/images/pencil.svg';

	const deleteUserOp = (userEmail: string, userRole: string) => {
		return new Promise((resolve) =>
			mutate(client, {
				mutation: deleteUser,
				variables: {
					email: userEmail,
					role: userRole
				},
				errorPolicy: 'all'
			})
				.then((dataResponse) => {
					resolve(dataResponse);
				})
				.catch((err) => {
					console.warn(err);
					resolve({ errors: err });
				})
		);
	};

	const handleDeleteUser = async () => {
		const result = confirm('Do you really want to delete this user?');
		if (result) {
			return deleteUserOp(row.email, row.role)
				.then(() => {
					dispatch('refresh');
					alert('User was deleted');
				})
				.catch(() => {
					alert('There was some problem during deleting the user. Try it again please.');
				});
		}
	};
</script>

<div class="wrapper">
	{row.role}

	{#if $userInfo.role === 'SUPERADMIN' || ($userInfo.role === 'ADMIN' && row.role !== 'SUPERADMIN')}
		<div>
			<Link to="/user_management/change/{row.email}/{row.role}">
				<img class="small" src={editIcon} alt="Edit icon" />
			</Link>
			<img class="small" src={deleteIcon} alt="Delete icon" on:click={handleDeleteUser} />
		</div>
	{/if}
</div>

<style lang="scss">
	.wrapper {
		display: flex;
		justify-content: space-between;
		align-items: center;

		img {
			width: 30px;
			height: 30px;
			cursor: pointer;
		}
	}
</style>
